var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ten-divider",class:[
    ("ten-divider__" + _vm.direction),
    { 'ten-divider__dashed': _vm.dashed && _vm.direction === 'horizontal' }
  ]},[(_vm.hasSlot && _vm.direction === 'horizontal')?_c('div',{staticClass:"ten-divider__title",class:( _obj = {}, _obj[("ten-divider__title-" + _vm.align)] = _vm.direction === 'horizontal', _obj )},[_c('div',[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }